(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'animate'
        );
        return;
      }

      if (scrollTop > 0) {
        this.header.classList.add(
          'shopify-section-header-sticky',
          'scrolled-past-header'
        );
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.remove(
          'shopify-section-header-sticky',
          'shopify-section-header-hidden',
          'scrolled-past-header',
          'animate'
        );
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header?.querySelectorAll('header-menu');
      this.disclosures?.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header?.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
